const state = {
  STATUS: null,
  API_ROUTE: "/patient/?detailed=true",
  patientsList: [],
  totalReaderPatients: 0
}

const getters = {
  patientsList: (state) => state.patientsList,
  totalReaderPatients: (state) => state.totalReaderPatients
}

const mutations = {
  setPatients(state, patients) {
    state.patientsList = patients
  },
  setTotalReaderPatients(state, total) {
    state.totalReaderPatients = total
  }
}

const actions = {
  async listPatients({ commit }, { offset = 0, limit = 10, search = null, orgId = null } = {}) {
    try {
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}`
      const config = {
        params: { offset, limit, detailed: true, search, userName: sessionStorage.getItem("username"), orgId }
      }

      const response = await window.axios.get(url, config)
      commit("setPatients", response.data.patients)
      commit("setTotalReaderPatients", response.data.total)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
